export default {
  menu: {
    config: "Settings",
    cambiarPass: "Change password",
    cambiarFoto: "Change profile picture",
    modoOscuro: "Dark mode",
    soporte: "Support",
    logout: "Log out"
  },
  cuenta: {
    titulo: "My account",
    tituloLargo: "Account settings",
    nombreTaller: "Workshop name",
    zonaHoraria: "Time zone",
    dominio: "Domain"
  },
  deptos: {
    titulo: "Departments",
    nuevo: "New department",
    editar: "Edit department",
    eliminar: "Delete department",
    pregEliminar: "Are you sure you want to delete the department?"
  },
  logos: {
    titulo: "Logo and printing",
    logo: "Logo",
    logoDer: "Right-side logo",
    txtLegal: "Legal text",
    txtCompra: "Purchase order text",
    vias: "Copies",
    via: "Copy",
    impresionOrd: "Order print layout",
    impresionApp: "App print layout",
    carta: "Letter",
    mismoEncabezado: "Use the same header for printing at all branches"
  },
  correos: {
    titulo: "Email design",
    encabezado: "Header",
    pie: "Footer",
    insertarImagen: "Insert image"
  },
  servicios: {
    titulo: "Service settings",
    clienteValida: "Client must validate service start and end with password",
    tecnicoFallas: "Technician must register detected issues in the order",
    tecnicoApertura: "Technician must initiate service opening",
    clienteDispone: "Client has",
    estadoReabrir: "days to reopen a service. When reopened, change to status",
    visualizarPrev: "Show scheduled preventive services with",
    diasAnticipacion: "days in advance",
    estadoFinalizar: "When the service is completed, change to status"
  },
  reparaciones: {
    titulo: "Repair settings",
    estadoFinalizar: "When the repair is completed, change to status",
    campoLibre: "Custom field name"
  },
  estadosServ: {
    titulo: "Service statuses",
    nuevo: "New status",
    editar: "Edit status",
    eliminar: "Delete service status",
    pregEliminar: "Are you sure you want to delete the status?",
    tarea: "Task to perform when the service is in this status"
  },
  estadosRep: {
    titulo: "Repair statuses",
    nuevo: "New status",
    editar: "Edit status",
    eliminar: "Delete repair status",
    pregEliminar: "Are you sure you want to delete the status?",
    tarea: "Task to perform when the repair is in this status"
  },
  mantenimiento: {
    titulo: "Maintenance",
    gestores: "Area managers",
    sucursales: "Enable branches in equipment",
    moduloObras: "Enable Works module.",
    moduloVehicular: "Enable vehicle maintenance module.",
    cambioAceite: "Oil change alert at: ",
    kms: "Kms or at: ",
    horas: "Hours",
    ver: "View scheduled maintenance with",
    dias: "days in advance",
  },
  presupuesto: {
    titulo: "Budget settings",
    concepto: "Use labor concepts in the budget",
    precioAuto: "Enable automatic pricing by equipment type in legal notes when printing",
    rma: "Include RMA cost in the budget",
    porDefecto: "Default value if no price is entered for an equipment type:",
    cliente: "If the client does not respond to the budget in ",
    presup: " days, change the budget to status: ",
    orden: " and the order to status: ",
    estadoPresup: "Budget status",
    estadoOrden: "Repair status"
  },
  categorias: {
    titulo: "Categories",
    nueva: "New category",
    editar: "Edit category",
    eliminar: "Delete category",
    pregEliminar: "Are you sure you want to delete the category?"
  },
  impuestos: {
    titulo: "Taxes",
    nuevo: "New tax",
    editar: "Edit tax",
    eliminar: "Delete tax",
    pregEliminar: "Are you sure you want to delete the tax?",
    porcentaje: "Percentage"
  },
  repuestos: {
    titulo: "Spare parts settings",
    precio: "Price to use for spare parts when calculating the budget: ",
    promedio: "Use weighted average price for the cost of items"
  },
  cotizacion: {
    titulo: "Currency exchange rate",
    nueva: "New exchange rate",
    editar: "Edit exchange rate",
    compra: "Buy",
    venta: "Sell",
    eliminar: "Delete exchange rate",
    pregEliminar: "Are you sure you want to delete the exchange rate?"
  },
  manoObra: {
    titulo: "Labor concepts",
    nueva: "New labor concept",
    editar: "Edit labor concept",
    eliminar: "Delete labor concept",
    pregEliminar: "Are you sure you want to delete the labor concept?"
  },
  notificaciones: {
    titulo: "Email Notifications",
    mailCliente: "Send email to the client on every status change of an order",
    noMailTecnico: "Do not send email to the technician and manager when an order is created",
    noMailCliente: "Do not send email to the client when an order is created",
    mailPresup: "Send repair order budget by email to clients every ",
    dias: " days"
  },
  app: {
    titulo: "APP",
    tituloLargo: "APP settings",
    agregarEquipos: "Allow adding equipment"
  },
  rubros: {
    titulo: "Sectors",
    nuevo: "New sector",
    editar: "Edit sector",
    eliminar: "Delete sector",
    pregEliminar: "Are you sure you want to delete the sector?"
  },
  generadorQR: {
    titulo: "QR Generator for Service Requests",
    msgEquipo: "Select a device to continue",
    msgCliente: "Select a client to continue",
    equipo: "Device (optional)",
    sinEquipo: "Enable this option if the requests are not linked to a device",
    registrarEquipo: "Register a new device",
    buscarEquipo: "Search a registered device",
    cliente: "Client (required)",
    registrarCliente: "Register a new client",
    buscarCliente: "Search a registered client",
    ubicacion: "Location",
    sucursal: "Branch (optional)",
    depto: "Department (optional)",
  },

}
